import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { birdProcurementAssigneesService, usersService } from '../services/apiServices';
import { BirdProcurementAssignee } from '../types';

const queryKeys = {
  all: ['birdProcurementAssignees'] as const,
  users: ['users'] as const,
};

export const useBirdProcurementAssignees = () => {
  return useQuery<BirdProcurementAssignee[]>({
    queryKey: queryKeys.all,
    queryFn: () => birdProcurementAssigneesService.getAll(),
  });
};

export const useUsers = () => {
  return useQuery<any[]>({
    queryKey: queryKeys.users,
    queryFn: () => usersService.getAll(),
  });
};

export const useSupervisors = () => {
  return useQuery<any[]>({
    queryKey: ['supervisors'],
    queryFn: async () => {
      const users = await usersService.getAll();
      return users.filter(
        (u: any) => u.role?.role_code === 'supervisor' || u.role === 'supervisor'
      );
    },
  });
};

export const useCreateBirdProcurementAssignee = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { procurement_ids: number[]; assignee_id: number }) =>
      birdProcurementAssigneesService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.all });
    },
  });
};

export const useDeleteBirdProcurementAssignee = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => birdProcurementAssigneesService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.all });
    },
  });
};
